import React, {useEffect, useRef, useState} from 'react';
import {mrbgTools} from "../../mrbgLib/mrbgTools.js";
import {mrbgStore, redFldToWhite, setSundryField} from './mrbgRedux/index.js';

function MrbgPersianDateTime({formID,name,type,other,storeInRedux,alwaysOpen,formStyle}){

	const
		format = type==='dateTime'? {y:'YYYY',m:'MM',d:'DD',h:'--',i:'--'}: {y:'YYYY',m:'MM',d:'DD'},
		pattern = type==='dateTime'? /^\d{4}(-|\/)\d{2}(-|\/)\d{2} \d{2}:\d{2}(:\d{2})?$/: /^\d{4}(-|\/)\d{2}(-|\/)\d{2}$/,
		MPDT = useRef( null ),
		pMax = {
			y: {c:1000, l:4, v:3000, d:'YYYY',},
			m: {c:1   , l:2, v:12  , d:'MM'},
			d: {c:3   , l:2, v:31  , d:'DD'},
			h: {c:2   , l:2, v:23  , d:'--'},
			i: {c:5   , l:2, v:59  , d:'--'},
		},
		[jalaliObj , setJalaliObj] = useState( format ),
		[defaultDate ,setDefaultDate ] = useState( getSetting() ),
		[pName,setPName ] = useState( null ),
		[isOpen,setIsOpen] = useState(alwaysOpen),
		[redFld,setRedFld] = useState( mrbgStore.getState().formsSettings[formID]?.redFld );

	var
		curVal = {...format},
		cnt = 0;

	function getSetting( dateTime ){

		var today    = new Date().toLocaleString("fa-IR-u-nu-latn", {timeZone: 'Asia/Tehran'}).split(',')[0];
		dateTime = dateTime?? today;

		var
			[y,m,d,h,i] = dateTime.split(/\/|, |:/),
			myObj   =
				type === 'dateTime'?
					{y,m,d,h,i,today}:
					{y,m,d,today};

		myObj.FDY = (new Date(mrbgTools.Calendar.j2m(`${y}/${m}/1`)).getDay()+1)%7;

		return myObj;
	}
	function openClose(){
		if( alwaysOpen || MPDT.current.classList.contains(formStyle.disable) )
			return false;

		var newVal = arguments.length? arguments[0]: !isOpen;
		if( newVal !== isOpen )
			setIsOpen( newVal );
	}
	function closeListener(e){
		if( MPDT.current && !MPDT.current.contains(e.target) ){
			openClose(false);
			document.removeEventListener('pointerdown',closeListener);
		}
	}
	function blurListener(e){
		if( MPDT.current && !(MPDT.current.querySelector(`.${formStyle.mrbgPersianDateTimeVV}`)).contains(e.target) ){
			setPName(null);
			document.removeEventListener('pointerdown',blurListener);
		}
	}
	function highlight(e){
		var spanIndex;
		if( e.type==='click' && e.target.tagName==='DIV' ){
			spanIndex = Math.floor(parseInt(mrbgTools.rng.getCursorPos(e.target)[1][0])/2);
			mrbgTools.rng.highLightText(e.target.querySelectorAll('span')[spanIndex]);
		}
		else{
			spanIndex = Array.prototype.indexOf.call(e.target.parentNode.children, e.target);
			mrbgTools.rng.highLightText(e.target.parentElement.querySelectorAll('span')[spanIndex]);
		}
		setPName(Object.keys(format)[spanIndex]);
	}
	function listenKyeUp(e){
		e.preventDefault();
		if( /^\d$/.test(e.key) ){
			curVal[pName] =
				Math.min(
					parseInt((parseInt(curVal[pName]) || 0).toString()+e.key),
					pMax[pName].v
				).toString().padStart(pMax[pName].l,0);

			cnt++;

			rangeUpdate( curVal[pName] );
			if( (pMax[pName].c && parseInt(curVal[pName])>pMax[pName].c) || cnt>=pMax[pName].l ){
				document.removeEventListener('keyup',listenKyeUp);
				if( pName === Object.keys(format).slice(-1)[0] ){
					mrbgTools.rng.deselectText()
					setPName(null)
				}
				else{
					var el = MPDT.current.querySelector( `span[data-name="${ pName }"]` ).nextElementSibling;
					el.focus();
					const sel = window.getSelection();
					if( !sel || !sel.rangeCount || sel.isCollapsed ){
						const range = document.createRange();
						range.selectNodeContents( el );
						sel.removeAllRanges();
						sel.addRange( range );
						range.detach();
					}
				}
			}
		}
		else if( e.key==='Backspace'||e.key==='Delete' ){
			if( curVal[pName]===pMax[pName]['d'] )
				MPDT.current.querySelector(`span[data-name="${pName}"]`).previousElementSibling?.focus()
			else{
				curVal[pName] =
					parseInt(curVal[pName]) < 10?
						pMax[pName]['d']:
						Math.floor(parseInt(curVal[pName])/10).toString().padStart(pMax[pName]['l'],0);

				cnt--;
				rangeUpdate( curVal[pName] );
			}
		}
	}
	function rangeUpdate(val){
		let range = mrbgTools.rng.getRange()[0];
		mrbgTools.rng.newValue(range, val);
	}
	function date2Obj( datetime ){
		var [y,m,d,h,i] = datetime.split(/\/|\s|:/);
		return type==='dateTime'? {y,m,d,h,i}: {y,m,d};
	}
	function obj2Date( obj ){
		return type==='dateTime'? `${obj.y}/${obj.m}/${obj.d} ${obj.h}:${obj.i}`: `${obj.y}/${obj.m}/${obj.d}`;
	}

	useEffect(() => {
		curVal = date2Obj( MPDT.current.querySelector(`.${formStyle.mrbgPersianDateTimeVV}`).textContent );
		cnt =
			!pName || curVal[pName]===pMax[pName]['d']?
				0:
				parseInt(curVal[pName]).toString().length;

		if( pName ){
			document.addEventListener('keyup', listenKyeUp );
			document.addEventListener('pointerdown', blurListener);
		}

		if( pattern.test(obj2Date(curVal)) ){
			if( JSON.stringify(jalaliObj) !== JSON.stringify(curVal) )
				setJalaliObj(curVal)
		}
		else if( !pName && JSON.stringify(jalaliObj)!==JSON.stringify(format) ){
			setJalaliObj({...format })
		}

		return () =>{
			document.removeEventListener('keyup', listenKyeUp );
			document.removeEventListener('pointerdown', blurListener);
		}
	},[pName]);
	useEffect(() => {
		if( isOpen )
			document.addEventListener('pointerdown', closeListener);

		return ()=> document.removeEventListener('pointerdown',closeListener);
	},[isOpen]);
	useEffect(() => {
		const unsubscribe = mrbgStore.subscribe(()=>{
			setRedFld(mrbgStore.getState().formsSettings[formID]?.redFld)
		})
		return () =>unsubscribe();
	},[])

	return(
		<>
			<div name={name} className={`${formStyle.mrbgPersianDateTimeFrame} ${redFld?.includes(name)? formStyle.emptyField:''}`} ref={MPDT}>
				<PDT_VV {...{jalaliObj,isOpen,type,openClose,highlight,setPName,formStyle}} />
				{
					isOpen?
						<PDT_DD {...{jalaliObj,setJalaliObj,pattern,isOpen,type,defaultDate,setDefaultDate,openClose,getSetting,formStyle}}/>:
						''
				}
			</div>
			<MdiInput {...{formID,name,jalaliObj,setJalaliObj,isOpen,format,type,pattern,redFld,date2Obj,obj2Date,storeInRedux}} />
		</>
	)
}

// PERSIAN_DATE_TIME__VIEW_VALUE ____________________________________
function PDT_VV({jalaliObj,isOpen,openClose,highlight,setPName,type,formStyle}){

	return(
		<>
			<div className={`${formStyle.mrbgPersianDateTimeVV} ${isOpen?formStyle.opened:''}`} onClick={e=>highlight(e)} onBlur={()=>setPName(null)}>
				<span data-name="y" tabIndex={0} inputMode="numeric" onFocus={e=>highlight(e)}>{jalaliObj.y}</span>/
				<span data-name="m" tabIndex={0} inputMode="numeric" onFocus={e=>highlight(e)}>{jalaliObj.m}</span>/
				<span data-name="d" tabIndex={0} inputMode="numeric" onFocus={e=>highlight(e)}>{jalaliObj.d}</span>
				{
					type==='dateTime'?
					<>
						{' '}
						<span data-name="h" tabIndex={0} inputMode="numeric" onFocus={e=>highlight(e)}>{jalaliObj.h}</span>:
						<span data-name="i" tabIndex={0} inputMode="numeric" onFocus={e=>highlight(e)}>{jalaliObj.i}</span>
					</>:
					''
				}
			</div>
			<span onClick={()=>openClose()}>&#128197;</span>
		</>
	)
}

// PERSIAN_DATE_TIME__DROP_DOWN ______________________________________
function PDT_DD({jalaliObj,setJalaliObj,pattern,isOpen,type,defaultDate,setDefaultDate,openClose,getSetting,formStyle}){

	return(
		<div className={`${formStyle.mrbgPersianDateTimeDD} ${!isOpen?formStyle.minimize:''}`}>
			<PDT_DD_YM {...{defaultDate,setDefaultDate,getSetting,formStyle}} />
			<PDT_DD_DT {...{jalaliObj,setJalaliObj,pattern,type,defaultDate,openClose,formStyle}} />
		</div>
	)
}


// PERSIAN_DATE_TIME__DROP_DOWN__YEAR_MONTH __________________________
function PDT_DD_YM({defaultDate,setDefaultDate,getSetting,formStyle}){

	return(
		<div className={`${formStyle.PDT_DD_YM} ${formStyle.flexRow}`}>
			<PDT_DD_M {...{defaultDate,setDefaultDate,getSetting,formStyle}}/>
			<PDT_DD_Y {...{defaultDate,setDefaultDate,getSetting,formStyle}}/>
		</div>
	)
}
function PDT_DD_M({defaultDate,setDefaultDate,getSetting,formStyle}){

	const monthList = ['فروردین','اردیبهشت','خرداد','تیر','مرداد','شهریور','مهر','آبان','آذر','دی','بهمن','اسفند'];

	function changeMonth(sign){
		let newCurM =
					(sign == '+')?
					Math.min(parseInt(defaultDate.m)+1,12):
					Math.max(parseInt(defaultDate.m)-1,1 );
		setDefaultDate( getSetting(`${defaultDate.y}/${newCurM}/${defaultDate.d}`) );
	}

	return(
		<div className={formStyle.PDT_DD_M}>
			<i className="fa-solid fa-caret-up" onClick={()=>changeMonth('-')}></i>
			<i className="fa-solid fa-caret-down" onClick={()=>changeMonth('+')}></i>
			<ul style={{'transform': 'translateY('+((defaultDate.m-1)*-28)+'px)'}}>
				{
					monthList.map((m,i)=><li key={i+1}>{m}</li> )
				}
			</ul>
		</div>
	)
}
function PDT_DD_Y({defaultDate,setDefaultDate,getSetting,formStyle}){

	function changeYear(sign){
		let newCurY =
					( sign == '+' )?
						Math.min( parseInt( defaultDate.y ) + 1, 3000 ):
						Math.max( parseInt( defaultDate.y ) - 1, 0 );
		setDefaultDate( getSetting(`${newCurY}/${defaultDate.m}/${defaultDate.d}`) );
	}

	return(
		<div className={formStyle.PDT_DD_Y}>
			<i className="fa-solid fa-caret-up" onClick={()=>changeYear('+')}></i>
			<i className="fa-solid fa-caret-down" onClick={()=>changeYear('-')}></i>
			<span>{defaultDate.y}</span>
		</div>
	)
}

// PERSIAN_DATE_TIME__DROP_DOWN__DATE_TIME __________________________
function PDT_DD_DT({jalaliObj,setJalaliObj,pattern,type,defaultDate,openClose,formStyle}){

	return(
		<div className={`${formStyle.PDT_DD_DT} ${formStyle.flexRow}`}>
			<div className={formStyle.mrbgPersianCalendar}>
				<PDT_DD_DT_D_name {...{formStyle}}/>
				<PDT_DD_DT_D_number  {...{jalaliObj,setJalaliObj,defaultDate,openClose,formStyle}}/>
			</div>
			{
				type=='dateTime'?
				<div className={formStyle.mrbgPersianTime}>
					<PDT_DD_DT_T_hour   {...{jalaliObj,setJalaliObj,pattern,openClose,formStyle}} />
					<PDT_DD_DT_T_minute {...{jalaliObj,setJalaliObj,pattern,openClose,formStyle}} />
				</div>:
				''
			}
		</div>
	)
}
function PDT_DD_DT_D_name({formStyle}){

	const dayName = ['ش','ی','د','س','چ','پ','ج'];

	return(
		<ul className={formStyle.PDT_DD_DT_D_name}>
			{
				dayName.map((d,i)=><li key={i}>{d}</li>)
			}
		</ul>
	)
}
function PDT_DD_DT_D_number({jalaliObj,setJalaliObj,defaultDate,openClose,formStyle}){

	const isLeap = mrbgTools.Calendar.jLaepYear.includes(parseInt(defaultDate.y))? true: false;

	function handleClick(span){
		setJalaliObj( {...jalaliObj, y:defaultDate.y.toString().padStart(4,0), m:defaultDate.m.toString().padStart(2,0), d:span.innerText.padStart(2,0)} );
		if( !Object.hasOwn(jalaliObj,'h') || /^\d{2}:\d{2}$/.test(`${jalaliObj.h}:${jalaliObj.i}`) )
			openClose(false)
	}

	var l = defaultDate.m<=6? 31: 30;

	if( defaultDate.m==12 && !isLeap )
		l = 29;

	return(
		<ul className={formStyle.PDT_DD_DT_D_number}>
			{
				// NULL CELL
				[...Array(defaultDate.FDY)].map((x,i)=>{
					return <li className={formStyle.MPDTNC} key={i}></li>
				})
			}
			{
				[...Array(l)].map((x,i)=>{
					var cls;
					if( i+1==jalaliObj.d || defaultDate.today==`${defaultDate.y}/${defaultDate.m}/${i+1}` ){
						if( i+1==jalaliObj.d && defaultDate.today==`${defaultDate.y}/${defaultDate.m}/${i+1}` )
							cls = `  ${formStyle.PDT_todayDay}  ${formStyle.PDT_curentDay}`
						else
							cls =
								i+1==jalaliObj.d?
									` ${formStyle.PDT_curentDay}`:
									` ${formStyle.PDT_todayDay}`;
					}
					else
						cls = '';
					return <li className={`${formStyle.MPDTDN}${cls}`} onClick={e=>handleClick(e.target)} key={i}>{i+1}</li>
				})
			}
		</ul>
	)
}
function PDT_DD_DT_T_hour({jalaliObj,setJalaliObj,pattern,openClose,formStyle}){

	function handleClick(val){
		setJalaliObj( {...jalaliObj, h:val} );
		if( pattern.test(`${jalaliObj.y}-${jalaliObj.m}-${jalaliObj.d} ${val}:${jalaliObj.i}`) )
			openClose(false)
	}

	return(
		<div className={formStyle.PDT_DD_DT_D_timeList}>
			<span>ساعت</span>
			<ul>
				{
					[...Array(24)].map((x,i)=>{
						var hour = i.toString().padStart(2,'0');
						return <li className={jalaliObj.h==hour? formStyle.PDT_curent_H_I:''} key={i} onClick={()=>handleClick(hour)}>{hour}</li>
					})
				}
			</ul>
		</div>
	)
}
function PDT_DD_DT_T_minute({jalaliObj,setJalaliObj,pattern,openClose,formStyle}){

	function handleClick(val){
		setJalaliObj( {...jalaliObj, i:val} );
		if( pattern.test(`${jalaliObj.y}-${jalaliObj.m}-${jalaliObj.d} ${jalaliObj.h}:${val}`) )
			openClose(false)
	}

	return(
		<div className={formStyle.PDT_DD_DT_D_timeList}>
			<span>دقیقه</span>
			<ul>
				{
					[...Array(60)].map((x,i)=>{
						var minute = i.toString().padStart(2,'0');
						return <li className={jalaliObj.i==minute? formStyle.PDT_curent_H_I:''} key={i} onClick={()=>handleClick(minute)}>{minute}</li>
					})
				}
			</ul>
		</div>
	)
}

// HIDE INPUT ____________________________________________________________
function MdiInput({formID,name,jalaliObj,setJalaliObj,isOpen,format,type,pattern,redFld,date2Obj,obj2Date,storeInRedux}){

	const [gregorianDT , setGregorianDT] = useState( '' );

	useEffect(() => {
		if( pattern.test(gregorianDT) ){
			var newJalaliObj = date2Obj( mrbgTools.Calendar.m2j(gregorianDT) );
			if( JSON.stringify(newJalaliObj)!==JSON.stringify(jalaliObj) )
				setJalaliObj(newJalaliObj);

			if( redFld.includes(name) )
				mrbgStore.dispatch(redFldToWhite({formID,name}));

			if( storeInRedux )
				mrbgStore.dispatch( setSundryField({formID,fieldName:name,fieldValue:gregorianDT}) )
		}
		else{
			if( gregorianDT!=='' )
				setGregorianDT('');
			if( JSON.stringify(jalaliObj)!==JSON.stringify(format) )
				setJalaliObj({...format});
		}
	},[gregorianDT]);
	useEffect(() => {
		var jalaliDT = obj2Date( jalaliObj )
		if( pattern.test(jalaliDT) ){
			var newGregorianDT = mrbgTools.Calendar.j2m(jalaliDT,type);
			if( newGregorianDT!==gregorianDT )
				setGregorianDT(newGregorianDT);
		}
		else if( !isOpen ){
			if( JSON.stringify(jalaliObj)!==JSON.stringify(format) )
				setJalaliObj({...format});
			if( gregorianDT!=='' )
				setGregorianDT('');
		}
	},[jalaliObj,isOpen])

	return <input type="hidden" name={name} value={gregorianDT} data-si={storeInRedux?true:false} onInput={e =>{setGregorianDT(e.target.value.trim())}}/>
}
export default MrbgPersianDateTime;